import { render, staticRenderFns } from "./RCreport.vue?vue&type=template&id=22ccc2a6&scoped=true"
import script from "./RCreport.vue?vue&type=script&lang=js"
export * from "./RCreport.vue?vue&type=script&lang=js"
import style0 from "./RCreport.vue?vue&type=style&index=0&id=22ccc2a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccc2a6",
  null
  
)

export default component.exports